import { z } from 'zod';
import { PROTOCOL_VERSION } from './version.js';
export const ControlEnvelope = z.object({
    v: z.literal(PROTOCOL_VERSION),
    id: z.string().min(1),
    ts: z.number().int().nonnegative(),
    type: z.string().min(1),
    payload: z.unknown(),
    correlationId: z.string().optional(),
});
//# sourceMappingURL=envelope.js.map